/**
 * Espejo de `cuentas/validadores.py` para el formulario de registro.
 *
 * El backend manda —valida lo mismo y rechaza igual—, pero repetir las
 * reglas aquí permite enseñarlas cumpliéndose mientras se escribe, en vez
 * de soltarlas todas de golpe al enviar.
 *
 * Si cambian las reglas, hay que cambiarlas en los dos sitios;
 * `tests/test_cuentas.py` cubre el lado que decide.
 */

const DOMINIOS_PUBLICOS = new Set(
  `gmail.com googlemail.com
   outlook.com outlook.es outlook.cl hotmail.com hotmail.es hotmail.cl
   live.com live.cl msn.com passport.com
   yahoo.com yahoo.es yahoo.com.ar yahoo.com.mx ymail.com rocketmail.com
   icloud.com me.com mac.com
   aol.com gmx.com gmx.es mail.com inbox.com
   protonmail.com proton.me pm.me tutanota.com tuta.io
   zoho.com yandex.com yandex.ru
   terra.cl terra.com vtr.net vtr.cl entelchile.net 123mail.cl
   mi.cl latinmail.com starmedia.com
   qq.com 163.com 126.com sina.com naver.com
   duck.com duckduckgo.com
   mailinator.com guerrillamail.com 10minutemail.com yopmail.com
   tempmail.com trashmail.com sharklasers.com throwawaymail.com`
    .split(/\s+/)
    .filter(Boolean),
)

export function esCorreoPersonal(correo: string): boolean {
  const dominio = correo.trim().toLowerCase().split('@')[1]
  return !!dominio && DOMINIOS_PUBLICOS.has(dominio)
}

export const LARGO_MINIMO_PASSWORD = 8

export interface ReglaPassword {
  texto: string
  cumple: boolean
}

export function reglasPassword(password: string): ReglaPassword[] {
  return [
    {
      texto: `${LARGO_MINIMO_PASSWORD} caracteres o más`,
      cumple: password.length >= LARGO_MINIMO_PASSWORD,
    },
    { texto: 'Alguna letra', cumple: /\p{L}/u.test(password) },
    { texto: 'Algún número', cumple: /\d/.test(password) },
    { texto: 'Una mayúscula', cumple: /\p{Lu}/u.test(password) },
    { texto: 'Un símbolo (. $ % #)', cumple: /[^\p{L}\p{N}\s]|_/u.test(password) },
  ]
}
